import React, { useRef, useState, useEffect } from "react";
import useOutsideClick from "../../../utils/hooks/useOutsideClickHook";
import { IoEllipsisVertical } from "react-icons/io5";
import actionIcon from "../../../assets/images/Kebab-check-list@2x.png";
import { Overlay } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddTaskModal from "../../Dailogs/AddTaskModal";
import { useSelector, useDispatch } from "react-redux";
import {
  AddComments,
  EmptyProductPart,
  GlobalRequest,
  RemoveDocsClientById,
} from "../../../redux/actions/action";
import { API_URL } from "../../../redux/constants/type";
import axios from "axios";
import CoWorkerModal from "./CoWorkerModal";
import { globalChat } from "../../../redux/actions/chatActions";

const GroupChatAction = ({
  onShowAction,
  selectedRoom,
  showModal,
  setShowModal,
  modalFunction,
  setModalFunction,
  taskId,
  setTaskId,
  primaryColor,
  groupDetails,
}) => {
  const dispatch = useDispatch();
  const textAreaRef = useRef("");
  const history = useHistory();
  const refOptions = useRef();
  const refOverlay = useRef();
  const [popups, setPopups] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [coWorkerModal, setCoWorkerModal] = useState(false);
  const [length, setLength] = useState("");
  const [taggedUser, setTaggedUser] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [minComments, setMinComments] = useState([]);
  const [comments, setComments] = useState([]);
  const [attachMessage, setAttachMessage] = useState("");
  const [show, setShow] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const [val, setVal] = useState("");
  const userId = window.localStorage.getItem("userid");
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [message, setMessage] = useState("");
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);
  const inputFile = React.useRef(null);
  const [imgUrl, setImgUrl] = useState("");
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );
  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes
  );

  const companyId = window.localStorage.getItem("companyid");
  const packageID = window.localStorage.getItem("packageId");

  const onButtonClick = () => {
    inputFile.current.click();
  };

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      })
    );
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  useEffect(() => {
    if (taskId) {
      fetchComments(taskId);
    }
  }, [taskId]);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  const toggleMenuOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742") {
      setShowNewTaskSystem(false);
    } else {
      if (packageID === process.env.REACT_APP_IS_PREMIUM) {
        setShowNewTaskSystem(true);
      }
    }
  }, [packageID, companyId]);

  const fetchComments = async (val) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: val,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  const handleAddComments = () => {
    dispatch(AddComments(userId, taskId, val, "task", imgUrl, taggedUser));
    setTimeout(() => {
      fetchComments(taskId);
    }, 1000);
    setTaggedUser([]);
    setVal("");
    setMessage("");
    setImgUrl("");
  };
  const handleFileChange = (data) => {
    setImgUrl(data.link);
    setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  const onMenuClick = (event, type) => {
    event.stopPropagation();
    event.preventDefault();
    setCoWorkerModal(false);

    switch (type) {
      case "TRANSFER":
        onShowAction();
        setCoWorkerModal(!coWorkerModal);
        break;
      case "CREATE_TASK":
        onShowAction();
        setModalFunction("add");
        setTaskId("");
        setShowModal(true);
        setMenuOpen(false);
        break;
      case "CREATE_CONTACT":
        onShowAction();
        setMenuOpen(false);
        dispatch(RemoveDocsClientById());
        dispatch(EmptyProductPart());
        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
        window.localStorage.setItem("selectedGroupId", selectedRoom?.groupid);
        dispatch(
          globalChat({
            userId,
            groupid: selectedRoom?.groupid ?? "",
            groupicon: selectedRoom?.groupicon ?? "",
            groupname: groupDetails[0].groupname,
            primarycolor: primaryColor,
          })
        );
        let adminUserIndex = groupDetails[0]?.groupuser?.findIndex(x => x.adminaccess == "Admin");
        let adminUser = {}
        if (adminUserIndex > -1) {
          adminUser.firstname = groupDetails[0]?.groupuser[adminUserIndex].firstname || "";
          adminUser.lastname = groupDetails[0]?.groupuser[adminUserIndex].lastname || "";
          adminUser.email = groupDetails[0]?.groupuser[adminUserIndex].email || "";
        }
        history.push("/add-contact", {
          chatWidgetContact: true,
          adminUser
        });
        break;
      default:
        break;
    }
  };

  useOutsideClick(() => setMenuOpen(false), [refOptions, refOverlay]);

  return (
    <>
      <div
        className="archive-chat-option-container"
        ref={refOptions}
        onClick={toggleMenuOpen}
      >
        <img
          src={actionIcon}
          style={{
            cursor: "pointer",
            width: "5px",
          }}
        />
      </div>
      <Overlay
        target={refOptions.current}
        show={isMenuOpen}
        placement="bottom-end"
        offset={[20, -30]}
      >
        {(props) => (
          <div {...props} style={{ ...props.style }}>
            <div
              className="chat-archive-menu-options-container"
              ref={refOverlay}
            >
              <div className="archive-menu-close-container">
                <div
                  className="archive-menu-close-button"
                  onClick={toggleMenuOpen}
                >
                  <IoEllipsisVertical fontSize={30} color="#A5A5A5" />
                </div>
              </div>
              <div
                className="action-menu-option-item"
                onClick={(e) => onMenuClick(e, "TRANSFER")}
              >
                Transfer to Co-worker
              </div>
              <div
                className="action-menu-option-item"
                onClick={(e) => onMenuClick(e, "CREATE_TASK")}
              >
                Create a Task
              </div>
              <div
                className="action-menu-option-item"
                onClick={(e) => onMenuClick(e, "CREATE_CONTACT")}
              >
                Create a Contact
              </div>
            </div>
          </div>
        )}
      </Overlay>
      {coWorkerModal && (
        <CoWorkerModal
          modalOpen={coWorkerModal}
          modalHideEv={() => setCoWorkerModal(false)}
          groupId={selectedRoom?.groupid}
          groupUsers={groupDetails[0]?.groupuser}
        />
      )}
      {showModal && (
        <AddTaskModal
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          val={val}
          setVal={setVal}
          textAreaRef={textAreaRef}
          // modelTypeId={modelTypeId}
          showModal={showModal}
          taskid={taskId}
          popups={popups}
          setPopups={setPopups}
          setTaskid={setTaskId}
          setShowModal={(show, reload) => {
            setShowModal(false);
          }}
          setComments={setComments}
          modalFunction={modalFunction}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          onButtonClick={onButtonClick}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          maxComments={maxComments}
          taggedUser={taggedUser}
          setTaggedUser={setTaggedUser}
          show={show}
          length={length}
          setLength={setLength}
          setShow={setShow}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          setMaxComments={setMaxComments}
          statusList={statusList}
          showNewTaskSystem={showNewTaskSystem}
        />
      )}
    </>
  );
};

export default GroupChatAction;
